/* RESPONSIBLE TEAM: team-data-foundations */
import ApplicationAdapter from 'embercom/adapters/application';
import ajax from 'embercom/lib/ajax';
import { inject as service } from '@ember/service';

export default ApplicationAdapter.extend({
  appService: service(),

  buildURL(modelName, id, snapshot, requestType, query) {
    return 'ember/stripe_settings';
  },

  // The server returns `head :ok` (200 with empty body) for updates.
  // dataType:'text' prevents jQuery from attempting JSON parse on the empty body.
  updateRecord(store, type, snapshot) {
    let data = this.serialize(snapshot);
    return ajax({
      url: '/ember/stripe_settings',
      type: 'PUT',
      data: JSON.stringify({ ...data, app_id: this.appService.app.id }),
      dataType: 'text',
    });
  },
});
